import PropTypes from 'prop-types';

const propTypes = {
  path: PropTypes.string.isRequired,
  isAuthenticated: PropTypes.bool,
  role: PropTypes.string,
};

const defaultProps = {
  isAuthenticated: false,
  role: '',
};

export { propTypes, defaultProps };
